import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {ActivatedRoute, Router} from '@angular/router';
import { URLSearchParams } from '@angular/http';

@Component({
  selector: "app-fiesta-club",
  templateUrl: "./fiesta-club.component.html",
  styleUrls: ["./fiesta-club.component.scss"]
})
export class FiestaClubComponent implements OnInit {
  public fiestaClubForm: FormGroup;
  public formSentSuccess = false;
  public formSubmitting = false;
  public showErrorMessage = false;


  constructor(private _fb: FormBuilder, private _router: Router) {
    this.fiestaClubForm = _fb.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      email: ["", Validators.pattern("[^ @]*@[^ @]*")],
      address: "",
      city: "",
      state: "",
      zip: "",
      birthDate: "",
      anniversary: "",
      favoriteLocation: ["", Validators.required],
      siteGUID: ["0A666386-46E4-471E-A0A8-E8FE3A514C0B"],
      ListID: ["4294967462"],
      InputSource: ["w"],
      returnURL: "https://www.rodrigos.com/fiesta-club/success",
    });
  }

  ngOnInit() {

  }

  submitForm() {
    window.open(
      "https://order.incentivio.com/c/rodrigosmexicangrill/signup",
      '_blank' // <- This is what makes it open in a new window.
    );
    // if(!this.fiestaClubForm.invalid) {
    //   let fiestaClubForm = {
    //     FirstName: this.fiestaClubForm.controls.firstName.value,
    //     LastName: this.fiestaClubForm.controls.lastName.value,
    //     EmailAddress: this.fiestaClubForm.controls.email.value,
    //     Address: this.fiestaClubForm.controls.address.value,
    //     City: this.fiestaClubForm.controls.city.value,
    //     State: this.fiestaClubForm.controls.state.value,
    //     Zip: this.fiestaClubForm.controls.zip.value,
    //     BirthDate: this.fiestaClubForm.controls.birthDate.value,
    //     Anniversary: this.fiestaClubForm.controls.birthDate.value,
    //     FavoriteLocation: this.fiestaClubForm.controls.favoriteLocation.value,
    //     SiteGUID: this.fiestaClubForm.controls.siteGUID.value,
    //     ListID: this.fiestaClubForm.controls.ListID.value,
    //     InputSource: this.fiestaClubForm.controls.InputSource.value,
    //     returnURL: this.fiestaClubForm.controls.returnURL.value
    //   };
    //   let params = new URLSearchParams;
    //   for(let key in fiestaClubForm) {
    //     params.set(key, fiestaClubForm[key]);
    //   }
    //   const url = 'http://rodrigos.fbmta.com/members/subscribe.aspx?' + params.toString();
    //   console.log(url);
    //   window.location.href = url;
    // } else {
    //   console.log(this.fiestaClubForm);
    //   this.showErrorMessage = true;
    // }

  }
}



// WEBPACK FOOTER //
// ./src/app/fiesta-club/fiesta-club.component.ts